import { rogueValleyStrawfest as rogueValleyStrawfestBase } from "@thirdparty/companies";

import { GtbCustomApp } from "../gtb/types";
import { towne } from "../towne";

export const rogueValleyStrawfest: GtbCustomApp = {
  ...rogueValleyStrawfestBase,
  routes: towne.routes,
};
